import { format } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';

// gets a date in UTC and transforms it to MM/dd/yyyy
export function getDateFormatFromUTC(
  date: string,
  outputFormat = 'MM/dd/yyyy'
): string {
  return date
    ? format(utcToZonedTime(new Date(date).toISOString(), 'UTC'), outputFormat)
    : '';
}
